import axios from 'axios'
import store from '../store'
/**
 * 拿OSS Token
 * @param {*} param
 */
export function ossSts(suffix, prefix) {
  const pro = axios({
    url: `/vb/asset/oss_sts_2?suffix=${suffix}&prefix=${prefix}`,
    method: 'get',
    headers: {
      'x-auth-token': store.state.user.token
    }
  })
  return pro
}

export async function doneUploadImg({
  uuid,
  assetPath,
  classify,
  privacy,
  atype
}) {
  const pro = await axios({
    url: '/vb/asset/create_2',
    method: 'post',
    headers: {
      'x-auth-token': store.state.user.token
    },
    data: {
      uuid,
      assetPath,
      classify,
      privacy,
      atype
    }
  })
  const { data } = pro
  if (data.code < 20000) {
    return Promise.reject(new Error(data.message))
  }
  return data.data
}

export async function getAssetList({ offset, limit, atype, uid = -1 }) {
  const requesQuery = {
    offset,
    limit,
    atype,
    pt: 'web'
  }
  if (uid !== -1) {
    // eslint-disable-next-line
    requesQuery.e_uid = uid
    // eslint-disable-next-line
    requesQuery.ol_upload = '1'
    // eslint-disable-next-line
    requesQuery.ol_like = '1'
  }
  const pro = await axios({
    url: '/vb/asset/wp_list_2',
    method: 'get',
    headers: {
      'x-auth-token': ''
    },
    params: requesQuery
  })
  const { data } = pro
  if (data.code < 20000) {
    return Promise.reject(new Error(data.message))
  }
  return data.data
}

export async function getAssetInfo(code) {
  const requesQuery = {
    atype: 8,
    code,
    pt: 'web'
  }

  const pro = await axios({
    url: '/vb/asset/info',
    method: 'get',
    params: requesQuery
  })
  const { data } = pro
  if (data.code < 20000) {
    return Promise.reject(new Error(data.message))
  }
  return data.data
}

export async function deleteAsset(id) {
  const pro = await axios({
    url: '/vb/asset/delete_2',
    method: 'delete',
    headers: {
      'x-auth-token': store.state.user.token
    },
    data: {
      id
    }
  })
  const { data } = pro
  if (data.code < 20000) {
    return Promise.reject(new Error(data.message))
  }
  return data.data
}

export async function sendCheckcode(mphone) {
  const pro = await axios({
    url: '/vb/user/vdblogin_checkcode',
    method: 'post',
    data: {
      mphone
    }
  })
  const { data } = pro
  if (data.code < 20000) {
    return Promise.reject(new Error(data.message))
  }
  return data.data
}

export async function vDbLogin({ account, checkcode, mpasswd }) {
  const pro = await axios({
    url: '/vb/user/v_db_login',
    method: 'post',
    data: {
      account,
      checkcode: checkcode ? checkcode : '',
      mpasswd: mpasswd ? mpasswd : ''
    }
  })
  const { data } = pro
  if (data.code < 20000) {
    return Promise.reject(new Error(data.message))
  }
  return data.data
}
